/*
 *
 * UserManagement reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  CREATE_USER,
  CREATE_USER_FAILURE,
  CREATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
  ACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  DEACTIVATE_USER_SUCCESS,
  START_IMPORT_USERS,
  START_IMPORT_USERS_SUCCESS,
  START_IMPORT_USERS_FAILURE,
  COMPLETE_IMPORT_USERS,
  COMPLETE_IMPORT_USERS_SUCCESS,
  COMPLETE_IMPORT_USERS_FAILURE,
  RESET_IMPORT_FILE,
  CHANGE_PAGINATION,
  RESET_STATE,
  DEFAULT_FETCH_USERS_LIMIT,
} from './constants';

export const initialState = fromJS({
  users: [],
  loadingUsers: false,
  errorLoadingUsers: null,
  pageSize: DEFAULT_FETCH_USERS_LIMIT,
  currentPage: 0,
  search: '',
  totalCount: 0,

  invalidRows: [],
  importFileIsValid: false,
  fileRowCount: null,
});

function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case START_IMPORT_USERS:
      return state.set('error', null).set('importFileIsValid', false);
    case START_IMPORT_USERS_SUCCESS:
      return state
        .set('fileRowCount', action.fileRowCount)
        .set('importFileIsValid', true);
    case START_IMPORT_USERS_FAILURE:
      return state
        .set('error', action.error)
        .set('importFileIsValid', false)
        .set('invalidRows', fromJS(action.invalidRows));
    case RESET_IMPORT_FILE:
      return state
        .set('importFileIsValid', false)
        .set('fieldRowCount', null)
        .set('invalidRows', fromJS([]));
    case COMPLETE_IMPORT_USERS:
      return state.set('error', null);
    case COMPLETE_IMPORT_USERS_SUCCESS:
      return state.set('importFileIsValid', true);
    case COMPLETE_IMPORT_USERS_FAILURE:
      return state
        .set('error', action.error)
        .set('importFileIsValid', false)
        .set('invalidRows', fromJS(action.invalidRows));
    case FETCH_USERS:
      return state
        .set('loadingUsers', true)
        .set('errorLoadingUsers', initialState.get('errorLoadingUsers'));
    case FETCH_USERS_SUCCESS:
      return state
        .set('loadingUsers', false)
        .set('users', fromJS(action.users))
        .set('totalCount', action.totalCount);
    case FETCH_USERS_FAILURE:
      return state
        .set('loadingUsers', false)
        .set('errorLoadingUsers', action.error);
    case CREATE_USER:
      return state.set('loading', true).set('error', null);
    case CREATE_USER_SUCCESS:
      return state.set('loading', false);
    case CREATE_USER_FAILURE:
      return state.set('loading', false).set('error', action.error);
    case CHANGE_PAGINATION:
      return state
        .set('pageSize', action.pageSize)
        .set('currentPage', action.currentPage)
        .set('search', action.search);
    case RESET_STATE:
      return initialState;
    case ACTIVATE_USER_SUCCESS:
    case DEACTIVATE_USER_SUCCESS:
    case ACTIVATE_USER_FAILURE:
    case DEACTIVATE_USER_FAILURE:
    default:
      return state;
  }
}

export default userManagementReducer;
